import React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import Spinner from 'react-bootstrap/Spinner';
import { CircularProgress } from '@mui/material';

const style = {
  position: 'absolute',
  textAlign:'center',
  top: '50%',
  left: '50%',
  height:220,
  transform: 'translate(-50%, -50%)',
  width: 220,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

export default function LoadingModal (props) {
  
  
  return (
    <div>
     
      <Modal
        open={props.Open}
        onClose={props.CloseModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="button" component="h2">
           <b>Creating your {props.Title}</b> 
          </Typography>
         
          <CircularProgress sx={{marginTop:'25px'}} color="primary" />
              
       <br></br>
       <Typography variant='caption'>Note: This could take several seconds</Typography>
        </Box>
      </Modal>
    </div>
  );
}